<template>
  <div
    :style="`position:relative;width:100%;height:${windowHeight}px;`"
  >
    <template v-if="data">
      <div
        v-for="box in boxes || []"
        :key="box.data.id"
        :style="`padding:1.5px; position:absolute; top:${box.y0}px; left:${box.x0 * ratio}px; bottom:${windowHeight - box.y1}px; right:${windowWidth - (box.x1 * ratio)}px;`"
      >
        <v-card
          style="width:100%;height:100%;"
          :color="box.data.color"
          :dark="dark(box.data.color)"
          flat
          :title="box.data.tooltip"
        >
          <v-card-title
            class="text-subtitle-1 py-0 px-2"
            style="height:100%"
          >
            <v-row
              align="center"
              style="width:100%"
            >
              <v-col
                class="text-center"
                style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis"
              >
                {{ box.data.title }}<br>
                {{ box.data.size.toLocaleString('fr') }}
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import tinycolor from 'tinycolor2'
  const d3 = require('d3-hierarchy')
  const seedColor = require('seed-color')

  const proportion = {
    linear: x => x,
    sqrt: x => Math.sqrt(x),
  }

  export default {
    data: () => ({
      boxes: null,
      ratio: 1.62,
    }),
    computed: {
      ...mapState(['data']),
      ...mapGetters(['config']),
    },
    watch: {
      data () {
        this.refresh()
      },
    },
    mounted () {
      this.refresh()
    },
    methods: {
      refresh () {
        if (!this.data) return
        const data = {
          children: this.data.map((a, i) => ({
            id: i,
            title: a.title,
            size: a.value,
            tooltip: `${a.title} - ${a.value.toLocaleString('fr')}`,
            color: this.config.color.type === 'uniform' ? 'primary' : seedColor(a.title).toHex(),
          })),
        }
        const hierarchy = d3.hierarchy(data)
          // .sum(d => d.size)
          .sum(d => proportion[this.config.proportion](d.size))
        d3.treemap()
          .size([this.windowWidth / this.ratio, this.windowHeight])
          .tile(d3.treemapSquarify.ratio(1))(hierarchy)

        this.boxes = hierarchy.leaves()
      },
      dark (color) {
        return tinycolor(color).getLuminance() < 0.4
      },
    },
  }
</script>

<style>
.v-application {
  font-family: "Nunito", sans-serif!important;
}
</style>
